export const USER_UPGRADE_CLEAR = 'USER_UPGRADE_CLEAR';

export const types = {
  // CLIENT DATA
  SET_CONSENTS_LIST: 'CONSENTS/SET_CONSENTS_LIST',
  GET_CONSENTS: 'CONSENTS/GET_CONSENTS',
  
  SAVE_CONSENTS: 'CONSENTS/SAVE_CONSENTS',
  SAVE_CONSENTS_SUCCESS: 'CONSENTS/SAVE_CONSENTS_SUCCESS',
  SAVE_CONSENTS_ERROR: 'CONSENTS/SAVE_CONSENTS_ERROR',
  SAVE_CONSENTS_RESET: 'CONSENTS/SAVE_CONSENTS_RESET',

  // OBD
  GET_OBD_CONSENTS_BEGINS: 'CONSENTS/GET_OBD_CONSENTS_BEGINS',
  GET_OBD_CONSENTS_SUCCESS: 'CONSENTS/GET_OBD_CONSENTS_SUCCESS',
  GET_OBD_CONSENTS_FAILURE: 'CONSENTS/GET_OBD_CONSENTS_FAILURE',
  GET_OBD_CONSENTS_RESET: 'CONSENTS/GET_OBD_CONSENTS_RESET',

  SAVE_OBD_CONSENTS_BEGINS: 'CONSENTS/SAVE_OBD_CONSENTS_BEGINS',
  SAVE_OBD_CONSENTS_SUCCESS: 'CONSENTS/SAVE_OBD_CONSENTS_SUCCESS',
  SAVE_OBD_CONSENTS_FAILURE: 'CONSENTS/SAVE_OBD_CONSENTS_FAILURE',
}

export const initialState = {
  // CLIENT DATA
  consentsList: null,
  consentsListError: false,
  
  
  consentsFetching: false,
  saveConsentsSuccess: false,
  saveConsentsPDF: null,
  saveConsentsError: false,
  failedConsents: null,
  succeededConsents: null,
  saveConsentsFetching: false,

  // OBD
  obdConsents: null,
  obdConsentsFetching: false,
  obdConsentsFetched: false,
  obdConsentsError: false,

  saveObdConsents: null,
  saveObdConsentsFetching: false,
  saveObdConsentsError: false,
}

const actionToStatus = (partyRoleConsentAction) =>
  partyRoleConsentAction === "Aceptado" ? "Aceptado" : "Rechazado";

const applySucceededToConsents = (stateConsents, succeeded) => {
  const newConsents = { ...stateConsents };

  Object.values(succeeded).forEach((consent) => {
    const {
      partyRoleConsentId,
      partyRoleName, // si existe => es línea
      partyRoleConsentAction,
    } = consent;

    const newStatus = actionToStatus(partyRoleConsentAction);

    // Caso 1: consentimiento de titular (no tiene partyRoleName)
    if (!partyRoleName) {
      if (newConsents[partyRoleConsentId]) {
        newConsents[partyRoleConsentId] = {
          ...newConsents[partyRoleConsentId],
          status: newStatus,
        };
      }
      return;
    }

    // Caso 2: consentimiento de línea => buscarlo en todos los padres
    Object.keys(newConsents).forEach((parentKey) => {
      const parent = newConsents[parentKey];

      if (!parent?.childrenConsents?.length) return;

      const idx = parent.childrenConsents.findIndex(
        (child) =>
          child.partyRoleConsentId === partyRoleConsentId &&
          child.kind === partyRoleName
      );

      if (idx === -1) return;

      const updatedChildren = [...parent.childrenConsents];
      updatedChildren[idx] = {
        ...updatedChildren[idx],
        status: newStatus,
      };

      newConsents[parentKey] = {
        ...parent,
        childrenConsents: updatedChildren,
      };
    });
  });

  return newConsents;
};

const ConsentReducers = (state = initialState, action) => {
  switch (action.type) {
    case USER_UPGRADE_CLEAR:
      return initialState;
    case types.GET_CONSENTS:
      return { ...state, consentsFetching: true }
    case types.SET_CONSENTS_LIST: {
      const { consentsList, consentsListError } = action.payload;
      return {
        ...state,
        consentsList,
        consentsListError,
      }
    }

    case types.SAVE_CONSENTS:
      return {
        ...state,
        saveConsentsFetching: true,
      }


    case types.SAVE_CONSENTS_ERROR:
      return {
        ...state,
        saveConsentsFetching: false,
        saveConsentsError: true,
        saveConsentsSuccess: false,
        failedConsents: action.payload?.failed,
        succeededConsents: action.payload?.succeeded,
      }
    case types.SAVE_CONSENTS_SUCCESS: {
      const succeeded = action.payload?.succeeded;

      let newConsentsList = {
        ...state.consentsList,
      }
      if (succeeded) {
        newConsentsList = applySucceededToConsents(state.consentsList, succeeded);
      }

      return {
        ...state,
        consentsList: newConsentsList,
        saveConsentsFetching: false,
        saveConsentsError: false,
        saveConsentsSuccess: true,
        saveConsentsPDF: action.payload,
      }
    }
    case types.SAVE_CONSENTS_RESET: {
      return {
        ...state,
        saveConsentsFetching: false,
        saveConsentsError: false,
        saveConsentsSuccess: false,
        saveConsentsPDF: null,
        failedConsents: null,
        succeededConsents: null,
      }
    }
    case types.GET_OBD_CONSENTS_BEGINS:
      return {
        ...state,
        obdConsents: null,
        obdConsentsFetching: true,
        obdConsentsFetched: false,
        obdConsentsError: false,
      }
    case types.GET_OBD_CONSENTS_SUCCESS: {
      return {
        ...state,
        obdConsents: action.payload,
        obdConsentsFetching: false,
        obdConsentsFetched: true,
        obdConsentsError: false,
      }
    }
    case types.GET_OBD_CONSENTS_FAILURE:
      return {
        ...state,
        obdConsents: null,
        obdConsentsFetching: false,
        obdConsentsFetched: true,
        obdConsentsError: action.payload,
      }
    case types.GET_OBD_CONSENTS_RESET:
      return {
        ...state,
        obdConsents: null,
        obdConsentsFetching: false,
        obdConsentsFetched: false,
        obdConsentsError: false,
      }
    case types.SAVE_OBD_CONSENTS_BEGINS:
      return {
        ...state,
        saveObdConsents: null,
        saveObdConsentsFetching: true,
        saveObdConsentsError: false,
      }
    case types.SAVE_OBD_CONSENTS_SUCCESS: {
      return {
        ...state,
        saveObdConsents: action.payload,
        saveObdConsentsFetching: false,
        saveObdConsentsError: false,
      }
    }
    case types.SAVE_OBD_CONSENTS_FAILURE:
      return {
        ...state,
        saveObdConsents: null,
        saveObdConsentsFetching: false,
        saveObdConsentsError: action.payload,
      }
    default:
      return state
  }
}

export const actions = {
  // Client data actions
  getClientConsents: () => ({ type: types.GET_CONSENTS }),
  setConsentsList: data => ({ type: types.SET_CONSENTS_LIST, payload: data }),

  saveConsents: sendConsentObj => ({ type: types.SAVE_CONSENTS, sendConsentObj }),
  saveConsentsSuccess: data => ({ type: types.SAVE_CONSENTS_SUCCESS, payload: data }),
  saveConsentsError: (payload) => ({ type: types.SAVE_CONSENTS_ERROR, payload }),
  resetSaveConsents: () => ({ type: types.SAVE_CONSENTS_RESET }),

  // OBD
  getOBDConsents: () => ({ type: types.GET_OBD_CONSENTS_BEGINS }),
  successGetOBDConsents: data => ({ type: types.GET_OBD_CONSENTS_SUCCESS, payload: data }),
  failureGetOBDConsents: error => ({ type: types.GET_OBD_CONSENTS_FAILURE, payload: error }),
  resetGetOBDConsents: () => ({ type: types.GET_OBD_CONSENTS_RESET }),

  saveOBDConsents: args => ({ type: types.SAVE_OBD_CONSENTS_BEGINS, args }),
  successSaveOBDConsents: data => ({ type: types.SAVE_OBD_CONSENTS_SUCCESS, payload: data }),
  failureSaveOBDConsents: error => ({ type: types.SAVE_OBD_CONSENTS_FAILURE, payload: error }),
}

export default ConsentReducers;
